// extracted by mini-css-extract-plugin
export default {"custom-modal-backdrop":"styles_custom-modal-backdrop__lCjap","custom-modal":"styles_custom-modal__6DR6L"};